module.exports = __webpack_public_path__ + "img/reset_power_step_3.bb7d54af.gif";